import React from "react";
import { useSelector } from "react-redux";
import { selectSpaceOrgsByCode } from "./slice";
import PropTypes from "prop-types";
import Country from "../geography/Country";
import styled from "styled-components";

const SpaceOrganisation = ({ code }) => {
	// NOTE this does need to have the space orgs loaded with an action
	const spaceOrgsByCode = useSelector(selectSpaceOrgsByCode); // The various types of RSO
	return (
		<span>
			{spaceOrgsByCode[code] && (
				<Country iso={spaceOrgsByCode[code].iso_code} />
			)}
			{spaceOrgsByCode[code] && <span>{spaceOrgsByCode[code].name}</span>}
		</span>
	);
};

SpaceOrganisation.propTypes = {
	code: PropTypes.string.isRequired, // THe code of the space organisation or country
};

export default SpaceOrganisation;
